import log from 'loglevel'

const rootName = '[Retail]'

const apply = (logger: log.Logger) => {
  const originalFactory = log.methodFactory
  logger.methodFactory = (methodName, logLevel, loggerName) => {
    const rawMethod = originalFactory(methodName, logLevel, loggerName)

    return function (message, args) {
      rawMethod(`${String(loggerName || rootName)} ${message}`, args)
    }
  }
  return logger
}

export default { apply }
